// edit: zhangmyh 2017-9-3 6:06 PM
/* global ko */

function viewText (params) {
  this.id = params.id || 'viewText'
  this.displayName = params.displayName || '字段'
  this.field = params.field
  this.short = false
  this.long = false
  this.outerData = !!(params.outerData)
  if (params.dataType == 'date') {
    this.text = ko.computed(function () {
      let text = params.model.ref(params.field)()
      if (text && text.length > 10) {
        return text.substr(0, 10)
      } else {
        return text
      }
    })
  } else {
    this.text = params.model.ref(params.field)
  }
  this.hasUnit = ko.computed(function () {
    let text = params.model.ref(params.field)()
    return (text && text != '' && params.unit && params.unit != '')
  })
  if (this.hasUnit()) {
    this.unit = params.unit
  } else {
    this.unit = ''
  }
  switch (params.size) {
    case 'sm':
      this.short = true
      break
    case 'lg':
      this.long = true
      break
    default:
      break
  }
}

export default viewText



// WEBPACK FOOTER //
// ./src/components/ag-form/view-span/index.js